import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/view/home/Home.vue"),
  },
  {
    path: "/xk",
    name: "LightFrame",
    component: () => import("@/view/light-frame/LightFrame.vue"),
  },
  {
    path: "/ypxk",
    name: "HardwareFrame",
    component: () => import("@/view/hardWare-frame/HardwareFrame.vue"),
  },
  {
    path: "/xc",
    name: "PhotohomeFrame",
    component: () => import("@/view/PhotohomeFrame/PhotohomeFrame.vue"),
  },
  {
    path: "/download",
    name: "DownloadPage",
    component: () => import("@/view/download/Download.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/view/about/About.vue"),
  },
];
const router = new Router({
  // linkActiveClass: 'link-active',
  // base: process.env.BASE_URL,
  // scrollBehavior () {
  //   return {x: 0, y: 0}
  // },
  routes,
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
  if (to.path !== "/home") {
    document.documentElement.style.filter = "";
    return;
  }

  // 很奇怪，如果设置document.body的filter属性，会导致左侧的fixed的导航栏浮动定位失效，但是也没有报错。。
  // 原因：如果父元素中存在filter属性，子元素使用position:fixed 将会相对于父元素定位
  const days = 5; // 黑白屏持续时间（单位：天）
  const timeStart = new Date("2022-11-30 16:33:14").getTime(); // 黑白屏开始时间
  const duration = days * 1000 * 60 * 60 * 24;
  if (timeStart + duration > Date.now()) {
    document.documentElement.style.filter = "grayscale(1)";
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js